export default class PropertyUtil {
    public static DeepFind(item: object, path: string) {
        const paths = path.split('.');
        let current = item;

        for (const pathChunk of paths) {
            if (PropertyUtil.SafeGet(() => current[pathChunk])) {
                current = current[pathChunk];
            } else {
                return undefined;
            }
        }
        return current;
    }

    /* tslint:disable-next-line */
    public static SafeGet(thing: () => any, defaultValue: any = undefined, format: string = undefined) {
        let value = undefined;

        try {
            value = thing();
        } catch (e) {
            value = undefined;
        }

        if (value === undefined) {
            return defaultValue;
        }

        if (format !== undefined) {
            return format.replace('{0}', value.toString());
        } else {
            return value;
        }
    }
}



// WEBPACK FOOTER //
// ./src/util/PropertyUtil.ts